function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';
import _ from 'underscore';
import downloadFASTA from './download_fasta';
import asMailtoHref from './mailto';
import CloudShareModal from './cloud_share_modal';
import DownloadLinks from 'download_links';
/**
 * checks whether code is being run by jest
 */
// eslint-disable-next-line no-undef
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var isTestMode = function isTestMode() {
  return process.env.JEST_WORKER_ID !== undefined || process.env.NODE_ENV === 'test';
};
/**
 * Renders links for downloading hit information in different formats.
 * Renders links for navigating to each query.
 */
var _default = /*#__PURE__*/function (_Component) {
  function _default(props) {
    var _this;
    _classCallCheck(this, _default);
    _this = _callSuper(this, _default, [props]);
    _this.downloadFastaOfAll = _this.downloadFastaOfAll.bind(_this);
    _this.downloadFastaOfSelected = _this.downloadFastaOfSelected.bind(_this);
    _this.topPanelJSX = _this.topPanelJSX.bind(_this);
    _this.summaryString = _this.summaryString.bind(_this);
    _this.indexJSX = _this.indexJSX.bind(_this);
    _this.downloadsPanelJSX = _this.downloadsPanelJSX.bind(_this);
    _this.handleQueryIndexChange = _this.handleQueryIndexChange.bind(_this);
    _this.isElementInViewPort = _this.isElementInViewPort.bind(_this);
    _this.setVisibleQueryIndex = _this.setVisibleQueryIndex.bind(_this);
    _this.debounceScrolling = _this.debounceScrolling.bind(_this);
    _this.scrollListener = _this.scrollListener.bind(_this);
    _this.copyURL = _this.copyURL.bind(_this);
    _this.shareCloudInit = _this.shareCloudInit.bind(_this);
    _this.sharingPanelJSX = _this.sharingPanelJSX.bind(_this);
    _this.cloudShareModal = /*#__PURE__*/React.createRef();
    _this.timeout = null;
    _this.queryElems = [];
    _this.state = {
      queryIndex: 1
    };
    return _this;
  }
  _inherits(_default, _Component);
  return _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      //keep track of the current queryIndex so it doesn't get lost on page reload
      var urlMatch = window.location.href.match(/#Query_(\d+)/);
      if (urlMatch && urlMatch.length > 1) {
        var queryNumber = +urlMatch[1];
        var index = this.props.data.queries.findIndex(function (query) {
          return query.number === queryNumber;
        });
        this.setState({
          queryIndex: index + 1
        });
      }
      window.addEventListener('scroll', this.scrollListener);
      $('a[href^="#Query_"]').on('click', this.animateAnchorElements);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.scrollListener);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.allQueriesLoaded && !prevProps.allQueriesLoaded) {
        /**
         * storing all query elements in this variable once they all become available so we don't have to fetch them all over again
         */
        this.queryElems = Array.from(document.querySelectorAll('.resultn'));
      }
    }

    /**
     * to avoid unnecessary computations, we debounce the scroll listener so it only fires after user has stopped scrolling for some milliseconds
     */
  }, {
    key: "scrollListener",
    value: function scrollListener() {
      this.debounceScrolling(this.setVisibleQueryIndex, 500);
    }
  }, {
    key: "debounceScrolling",
    value: function debounceScrolling(callback, timer) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(callback, timer);
    }

    /**
     * This method makes the page aware of what query is visible so that clicking previous / next button at any point
     * navigates to the proper query
     */
  }, {
    key: "setVisibleQueryIndex",
    value: function setVisibleQueryIndex() {
      var queryElems = this.queryElems.length ? this.queryElems : Array.from(document.querySelectorAll('.resultn'));
      var hits = Array.from(document.querySelectorAll('.hit[id^=Query_]'));
      // get the first visible element and marks it as the current query
      var topmostEl = queryElems.find(this.isElementInViewPort) || hits.find(this.isElementInViewPort);
      if (topmostEl) {
        var queryIndex = Number(topmostEl.id.match(/Query_(\d+)/)[1]);
        var hash = "#Query_".concat(queryIndex);
        // if we can guarantee that the browser can handle change in url hash without the page jumping,
        // then we update the url hash after scroll. else, hash is only updated on click of next or prev button
        if (window.history.pushState) {
          window.history.pushState(null, null, hash);
        }
        this.setState({
          queryIndex: queryIndex
        });
      }
    }
  }, {
    key: "animateAnchorElements",
    value: function animateAnchorElements(e) {
      // allow normal behavior in test mode to prevent warnings or errors from jquery
      if (isTestMode()) return;
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $(this.hash).offset().top
      }, 300);
      if (window.history.pushState) {
        window.history.pushState(null, null, this.hash);
      } else {
        window.location.hash = this.hash;
      }
    }
  }, {
    key: "isElementInViewPort",
    value: function isElementInViewPort(elem) {
      var _elem$getBoundingClie = elem.getBoundingClientRect(),
        top = _elem$getBoundingClie.top,
        left = _elem$getBoundingClie.left,
        right = _elem$getBoundingClie.right,
        bottom = _elem$getBoundingClie.bottom;
      return top >= 0 && left >= 0 && bottom <= (window.innerHeight || document.documentElement.clientHeight) && right <= (window.innerWidth || document.documentElement.clientWidth);
    }
    /**
         * Clear sessionStorage - useful to initiate a new search in the same tab.
         * Passing sessionStorage.clear directly as onclick callback didn't work
         * (on macOS Chrome).
        */
  }, {
    key: "clearSession",
    value: function clearSession() {
      sessionStorage.clear();
    }
    /**
     *
     * handle next and previous query button clicks
     */
  }, {
    key: "handleQueryIndexChange",
    value: function handleQueryIndexChange(nextQuery) {
      if (nextQuery < 1 || nextQuery > this.props.data.queries.length) return;
      var anchorEl = document.createElement('a');
      //indexing at [nextQuery - 1] because array is 0-indexed
      anchorEl.setAttribute('href', '#Query_' + this.props.data.queries[nextQuery - 1].number);
      anchorEl.setAttribute('hidden', true);
      document.body.appendChild(anchorEl);
      // add smooth scrolling animation with jquery
      $(anchorEl).on('click', this.animateAnchorElements);
      anchorEl.click();
      document.body.removeChild(anchorEl);
      this.setState({
        queryIndex: nextQuery
      });
    }
    /**
     * Event-handler for downloading fasta of all hits.
     */
  }, {
    key: "downloadFastaOfAll",
    value: function downloadFastaOfAll() {
      var sequence_ids = [];
      this.props.data.queries.forEach(function (query) {
        return query.hits.forEach(function (hit) {
          return sequence_ids.push(hit.id);
        });
      });
      var database_ids = this.props.data.querydb.map(function (querydb) {
        return querydb.id;
      });
      downloadFASTA(sequence_ids, database_ids);
      return false;
    }

    /**
     * Handles downloading fasta of selected hits.
     */
  }, {
    key: "downloadFastaOfSelected",
    value: function downloadFastaOfSelected() {
      var sequence_ids = $('.hit-links :checkbox:checked').map(function () {
        return this.value;
      }).get();
      if (sequence_ids.length === 0) {
        return false;
      }
      var database_ids = _.map(this.props.data.querydb, _.iteratee('id'));
      downloadFASTA(sequence_ids, database_ids);
      return false;
    }

    /**
     * Handles copying the URL into the user's clipboard. Modified from: https://stackoverflow.com/a/49618964/18117380
     * Hides the 'Copied!' tooltip after 3 seconds
     */
  }, {
    key: "copyURL",
    value: function copyURL() {
      var element = document.createElement('input');
      var url = window.location.href;
      document.body.appendChild(element);
      element.value = url;
      element.select();
      document.execCommand('copy');
      document.body.removeChild(element);
      var tooltip = document.getElementById('tooltip');
      tooltip.classList.remove('hidden');
      setTimeout(function () {
        tooltip.classList.add('hidden');
      }, 3000);
    }
  }, {
    key: "shareCloudInit",
    value: function shareCloudInit() {
      this.cloudShareModal.current.show();
    }
  }, {
    key: "topPanelJSX",
    value: function topPanelJSX() {
      var path = location.pathname.split('/');
      // Get job id.
      var job_id = path.pop();
      // Deriving rootURL this way is required for subURI deployments
      // - we cannot just send to '/'.
      var rootURL = path.join('/');
      return /*#__PURE__*/_jsxs("div", {
        className: "sidebar-top-panel",
        children: [/*#__PURE__*/_jsx("div", {
          className: "pl-px table mb-0 w-full",
          children: /*#__PURE__*/_jsx("h4", {
            className: "text-sm font-bold mb-0 mt-0.5",
            children: this.summaryString()
          })
        }), this.props.data.queries.length > 12 && this.queryIndexButtons(), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("a", {
            href: "".concat(rootURL, "/?job_id=").concat(job_id),
            className: "text-sm text-seqblue hover:text-seqorange cursor-pointer",
            children: [/*#__PURE__*/_jsx("i", {
              className: "fa fa-pencil"
            }), " Edit search"]
          }), /*#__PURE__*/_jsx("span", {
            className: "text-seqorange px-1",
            children: "|"
          }), /*#__PURE__*/_jsxs("a", {
            href: "".concat(rootURL, "/"),
            onClick: this.clearSession,
            className: "text-sm text-seqblue hover:text-seqorange cursor-pointer",
            children: [/*#__PURE__*/_jsx("i", {
              className: "fa-regular fa-file"
            }), " New search"]
          })]
        }), this.props.shouldShowIndex && this.indexJSX()]
      });
    }
  }, {
    key: "summaryString",
    value: function summaryString() {
      var program = this.props.data.program;
      var numqueries = this.props.data.queries.length;
      var numquerydb = this.props.data.querydb.length;
      return program.toUpperCase() + ': ' + numqueries + ' ' + (numqueries > 1 ? 'queries' : 'query') + ', ' + numquerydb + ' ' + (numquerydb > 1 ? 'databases' : 'database');
    }
  }, {
    key: "queryIndexButtons",
    value: function queryIndexButtons() {
      var _this2 = this;
      var buttonStyle = {
        outline: 'none',
        border: 'none',
        background: 'none'
      };
      var buttonClasses = 'text-sm text-seqblue hover:text-seqorange hover:bg-gray-200';
      var handlePreviousBtnClick = function handlePreviousBtnClick() {
        return _this2.handleQueryIndexChange(_this2.state.queryIndex - 1);
      };
      var handleNextBtnClick = function handleNextBtnClick() {
        return _this2.handleQueryIndexChange(_this2.state.queryIndex + 1);
      };

      // eslint-disable-next-line no-unused-vars
      var NavButton = function NavButton(_ref) {
        var text = _ref.text,
          onClick = _ref.onClick;
        return /*#__PURE__*/_jsx("button", {
          className: buttonClasses,
          onClick: onClick,
          style: buttonStyle,
          children: text
        });
      };
      return /*#__PURE__*/_jsxs("div", {
        style: {
          display: 'flex',
          width: '100%',
          margin: '7px 0'
        },
        children: [this.state.queryIndex > 1 && /*#__PURE__*/_jsx(NavButton, {
          text: "Previous Query",
          onClick: handlePreviousBtnClick
        }), this.state.queryIndex > 1 && this.state.queryIndex < this.props.data.queries.length && /*#__PURE__*/_jsx("span", {
          className: "text-seqorange px-1",
          children: "|"
        }), this.state.queryIndex < this.props.data.queries.length && /*#__PURE__*/_jsx(NavButton, {
          onClick: handleNextBtnClick,
          text: "Next Query"
        })]
      });
    }
  }, {
    key: "indexJSX",
    value: function indexJSX() {
      return /*#__PURE__*/_jsxs("ul", {
        className: "w-full",
        children: [" ", _.map(this.props.data.queries, function (query) {
          return /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx("a", {
              className: "side-nav text-sm text-seqblue hover:text-seqorange focus:text-seqorange active:text-seqorange cursor-pointer hover-bold line-clamp-1 mb-1.5",
              title: 'Query= ' + query.id + ' ' + query.title,
              href: '#Query_' + query.number,
              children: 'Query= ' + query.id
            })
          }, 'Side_bar_' + query.id);
        })]
      });
    }
  }, {
    key: "downloadsPanelJSX",
    value: function downloadsPanelJSX() {
      return /*#__PURE__*/_jsxs("div", {
        className: "downloads",
        children: [/*#__PURE__*/_jsx("div", {
          className: "pl-px table mb-0 w-full",
          children: /*#__PURE__*/_jsx("h4", {
            className: "text-sm font-bold mb-0 mt-2.5",
            children: "Download FASTA, XML, TSV"
          })
        }), /*#__PURE__*/_jsxs("ul", {
          children: [!(this.props.data.imported_xml || this.props.data.non_parse_seqids) && /*#__PURE__*/_jsx("li", {
            className: "hover:bg-gray-200 mb-1",
            children: /*#__PURE__*/_jsx("a", {
              href: "#",
              className: "text-sm text-seqblue download-fasta-of-all hover:text-seqorange cursor-pointer py-0.5 px-0.5 ".concat(!this.props.atLeastOneHit && 'disabled'),
              onClick: this.props.atLeastOneHit ? this.downloadFastaOfAll : function (e) {
                return e.preventDefault();
              },
              children: "FASTA of all hits"
            })
          }), !(this.props.data.imported_xml || this.props.data.non_parse_seqids) && /*#__PURE__*/_jsx("li", {
            className: "mb-1",
            children: /*#__PURE__*/_jsxs("a", {
              href: "#",
              className: "flex text-sm download-fasta-of-selected text-seqblue disabled py-0.5 px-0.5",
              onClick: this.downloadFastaOfSelected,
              children: ["FASTA of ", /*#__PURE__*/_jsx("span", {
                className: "font-bold px-0.5"
              }), " selected hit(s)"]
            })
          }), /*#__PURE__*/_jsx("li", {
            className: "hover:bg-gray-200 mb-1",
            children: /*#__PURE__*/_jsx("a", {
              href: "#",
              className: "text-sm text-seqblue download-alignment-of-all hover:text-seqorange cursor-pointer py-0.5 px-0.5 ".concat(!this.props.atLeastOneHit && 'disabled'),
              children: "Alignment of all hits"
            })
          }), /*#__PURE__*/_jsx("li", {
            className: "mb-1",
            children: /*#__PURE__*/_jsxs("a", {
              href: "#",
              className: "flex text-sm download-alignment-of-selected text-seqblue disabled py-0.5 px-0.5",
              children: ["Alignment of ", /*#__PURE__*/_jsx("span", {
                className: "font-bold px-0.5"
              }), " selected hit(s)"]
            })
          }), !this.props.data.imported_xml && /*#__PURE__*/_jsx("li", {
            className: "hover:bg-gray-200 mb-1",
            children: /*#__PURE__*/_jsx("a", {
              href: 'download/' + this.props.data.search_id + '.std_tsv',
              children: /*#__PURE__*/_jsx("div", {
                className: "relative flex flex-col items-center group",
                children: /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center w-full",
                  children: [/*#__PURE__*/_jsx("span", {
                    className: "w-full text-sm text-seqblue hover:text-seqorange download cursor-pointer py-0.5 px-0.5",
                    children: "Standard tabular report"
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "absolute hidden left-full ml-2 items-center group-hover:flex tooltip-wrap",
                    children: [/*#__PURE__*/_jsx("div", {
                      className: "w-0 h-0 border-y-8 border-r-8 border-t-transparent border-b-transparent border-r-black -mr-px"
                    }), /*#__PURE__*/_jsx("span", {
                      className: "relative z-10 p-2 side-tooltip-text leading-4 text-center text-white whitespace-no-wrap bg-black shadow-lg rounded-md",
                      children: "15 columns: query and subject ID; scientific name, alignment length, mismatches, gaps, identity, start and end coordinates, e value, bitscore, query coverage per subject and per HSP."
                    })]
                  })]
                })
              })
            })
          }), !this.props.data.imported_xml && /*#__PURE__*/_jsx("li", {
            className: "hover:bg-gray-200 mb-1",
            children: /*#__PURE__*/_jsx("a", {
              href: 'download/' + this.props.data.search_id + '.full_tsv',
              children: /*#__PURE__*/_jsx("div", {
                className: "relative flex flex-col items-center group",
                children: /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center w-full",
                  children: [/*#__PURE__*/_jsx("span", {
                    className: "w-full text-sm text-seqblue hover:text-seqorange download cursor-pointer py-0.5 px-0.5",
                    children: "Full tabular report"
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "absolute hidden left-full ml-2 items-center group-hover:flex tooltip-wrap",
                    children: [/*#__PURE__*/_jsx("div", {
                      className: "w-0 h-0 border-y-8 border-r-8 border-t-transparent border-b-transparent border-r-black -mr-px"
                    }), /*#__PURE__*/_jsx("span", {
                      className: "relative z-10 p-2 side-tooltip-text leading-4 text-center text-white whitespace-no-wrap bg-black shadow-lg rounded-md",
                      children: "44 columns: query and subject ID, GI, accessions, and length; alignment details; taxonomy details of subject sequence(s) and query coverage per subject and per HSP."
                    })]
                  })]
                })
              })
            })
          }), !this.props.data.imported_xml && /*#__PURE__*/_jsx("li", {
            className: "hover:bg-gray-200 mb-1",
            children: /*#__PURE__*/_jsx("a", {
              href: 'download/' + this.props.data.search_id + '.xml',
              children: /*#__PURE__*/_jsx("div", {
                className: "relative flex flex-col items-center group",
                children: /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center w-full",
                  children: [/*#__PURE__*/_jsx("span", {
                    className: "w-full text-sm text-seqblue hover:text-seqorange download cursor-pointer py-0.5 px-0.5",
                    children: "Full XML report"
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "absolute hidden left-full ml-2 items-center group-hover:flex tooltip-wrap",
                    children: [/*#__PURE__*/_jsx("div", {
                      className: "w-0 h-0 border-y-8 border-r-8 border-t-transparent border-b-transparent border-r-black -mr-px"
                    }), /*#__PURE__*/_jsx("span", {
                      className: "relative z-10 p-2 side-tooltip-text leading-4 text-center text-white whitespace-no-wrap bg-black shadow-lg rounded-md",
                      children: "Results in XML format."
                    })]
                  })]
                })
              })
            })
          }), !this.props.data.imported_xml && /*#__PURE__*/_jsx("li", {
            className: "hover:bg-gray-200 mb-1",
            children: /*#__PURE__*/_jsx("a", {
              href: 'download/' + this.props.data.search_id + '.pairwise',
              children: /*#__PURE__*/_jsx("div", {
                className: "relative flex flex-col items-center group",
                children: /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center w-full",
                  children: [/*#__PURE__*/_jsx("span", {
                    className: "w-full text-sm text-seqblue hover:text-seqorange download cursor-pointer py-0.5 px-0.5",
                    children: "Full Text report"
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "absolute hidden left-full ml-2 items-center group-hover:flex tooltip-wrap",
                    children: [/*#__PURE__*/_jsx("div", {
                      className: "w-0 h-0 border-y-8 border-r-8 border-t-transparent border-b-transparent border-r-black -mr-px"
                    }), /*#__PURE__*/_jsx("span", {
                      className: "relative z-10 p-2 side-tooltip-text leading-4 text-center text-white whitespace-no-wrap bg-black shadow-lg rounded-md",
                      children: "Results in text format."
                    })]
                  })]
                })
              })
            })
          }), /*#__PURE__*/_jsx(DownloadLinks, {
            imported_xml: this.props.data.imported_xml,
            search_id: this.props.data.search_id
          })]
        })]
      });
    }
  }, {
    key: "sharingPanelJSX",
    value: function sharingPanelJSX() {
      return /*#__PURE__*/_jsxs("div", {
        className: "sharing-panel",
        children: [/*#__PURE__*/_jsx("div", {
          className: "pl-px table mb-0 w-full",
          children: /*#__PURE__*/_jsx("h4", {
            className: "text-sm font-bold mb-0 mt-2.5",
            children: "Share results"
          })
        }), /*#__PURE__*/_jsxs("ul", {
          children: [!this.props.cloudSharingEnabled && /*#__PURE__*/_jsx("li", {
            className: "hover:text-seqorange hover:bg-gray-200",
            children: /*#__PURE__*/_jsx("a", {
              id: "copyURL",
              className: "flex text-sm text-seqblue hover:text-seqorange copy-URL cursor-pointer py-0.5 px-0.5 w-full",
              onClick: this.copyURL,
              children: /*#__PURE__*/_jsxs("div", {
                className: "relative flex gap-2 items-center group w-full",
                children: [/*#__PURE__*/_jsx("i", {
                  className: "fa fa-copy"
                }), /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center",
                  children: [/*#__PURE__*/_jsx("span", {
                    className: "w-full",
                    children: "Copy URL to clipboard"
                  }), /*#__PURE__*/_jsx("div", {
                    id: "tooltip",
                    className: "absolute hidden left-full ml-2 items-center",
                    children: /*#__PURE__*/_jsxs("div", {
                      className: "flex items-center",
                      children: [/*#__PURE__*/_jsx("div", {
                        className: "w-0 h-0 border-y-8 border-r-8 border-t-transparent border-b-transparent border-r-black -mr-px"
                      }), /*#__PURE__*/_jsx("span", {
                        className: "relative z-10 p-2 side-tooltip-text leading-4 text-center text-white whitespace-no-wrap bg-black shadow-lg rounded-md",
                        children: "Copied!"
                      })]
                    })
                  })]
                })]
              })
            })
          }), !this.props.cloudSharingEnabled && /*#__PURE__*/_jsx("li", {
            className: "hover:text-seqorange hover:bg-gray-200",
            children: /*#__PURE__*/_jsx("a", {
              id: "sendEmail",
              className: "flex text-sm text-seqblue hover:text-seqorange email-URL cursor-pointer py-0.5 px-0.5 w-full",
              href: asMailtoHref(this.props.data.querydb, this.props.data.program, this.props.data.queries.length, window.location.href),
              target: "_blank",
              rel: "noopener noreferrer",
              children: /*#__PURE__*/_jsxs("div", {
                className: "relative flex gap-2 items-center group w-full",
                children: [/*#__PURE__*/_jsx("i", {
                  className: "fa fa-envelope"
                }), /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center w-full",
                  children: [/*#__PURE__*/_jsx("span", {
                    className: "w-full",
                    children: "Send by email"
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "absolute hidden left-full ml-2 items-center group-hover:flex tooltip-wrap",
                    children: [/*#__PURE__*/_jsx("div", {
                      className: "w-0 h-0 border-y-8 border-r-8 border-t-transparent border-b-transparent border-r-black -mr-px"
                    }), /*#__PURE__*/_jsx("span", {
                      className: "relative z-10 p-2 side-tooltip-text leading-4 text-center text-white whitespace-no-wrap bg-black shadow-lg rounded-md",
                      children: "Send by email"
                    })]
                  })]
                })]
              })
            })
          }), this.props.cloudSharingEnabled && /*#__PURE__*/_jsx("li", {
            className: "hover:text-seqorange hover:bg-gray-200",
            children: /*#__PURE__*/_jsx("button", {
              className: "flex text-sm text-seqblue hover:text-seqorange cloud-Post cursor-pointer py-0.5 px-0.5 w-full",
              onClick: this.shareCloudInit,
              children: /*#__PURE__*/_jsxs("div", {
                className: "relative flex gap-2 items-center group w-full",
                children: [/*#__PURE__*/_jsx("i", {
                  className: "fa fa-cloud"
                }), /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center",
                  children: [/*#__PURE__*/_jsx("span", {
                    className: "w-full",
                    children: "Share to cloud"
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "absolute hidden left-full ml-2 items-center group-hover:flex tooltip-wrap",
                    children: [/*#__PURE__*/_jsx("div", {
                      className: "w-0 h-0 border-y-8 border-r-8 border-t-transparent border-b-transparent border-r-black -mr-px"
                    }), /*#__PURE__*/_jsx("span", {
                      className: "relative z-10 p-2 side-tooltip-text leading-4 text-center text-white whitespace-no-wrap bg-black shadow-lg rounded-md",
                      children: "Results in pairwise format Upload results to SequenceServer Cloud where it will become accessable to everyone who has a link."
                    })]
                  })]
                })]
              })
            })
          })]
        }), /*#__PURE__*/_jsx(CloudShareModal, {
          ref: this.cloudShareModal,
          querydb: this.props.data.querydb,
          program: this.props.data.program,
          queryLength: this.props.data.queries.length
        })]
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        className: "sidebar sticky top-0 print:hidden",
        children: this.topPanelJSX()
      });
    }
  }]);
}(Component);
export { _default as default };